<template>
  <div class="worksCenterdatails-section">
    <div class="datails-mark">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>作品中心</el-breadcrumb-item>
        <el-breadcrumb-item>作品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="datails-title">《{{ worksData.poetry_name }}》</div>
    <div class="datails-author">
      <span class="author-item">学生姓名：{{ worksData.author }}</span>
      <span class="author-item">指导老师：{{ worksData.teacher_name }}</span>
    </div>
    <div class="datail-information">
      <span
        >阅读量：
        <span class="information-value">{{ worksData.hits_number }}</span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span
        >点赞量：
        <span class="information-value">{{ worksData.praise_number }}</span>
      </span>
    </div>
    <div class="temporary_show-container" v-if="!worksData.author">
      暂无数据
    </div>
    <div class="datail-img">
      <img :src="(worksData.file || {}).file_src" />
    </div>
    <div class="worksCenterdatails-content">
      <div
        class="worksCenterdatails-main"
        v-html="worksData.poetry_content"
      ></div>
      <p class="worksCenterdatails-remarks">
        学生姓名：<span>{{ worksData.author }}</span> 年龄：<span>{{
          worksData.age
        }}</span>
        年级：<span>{{ (worksData.grade || {}).name }}</span> 学校：<span>{{
          school.name
        }}</span>
        指导老师：<span>{{ worksData.teacher_name }}</span>
      </p>
    </div>
    <div class="datail-button-content">
      <div class="left-button">
        <el-button
          type="primary"
          size="small"
          @click="() => this.$router.back()"
          >返回上一层</el-button
        >
      </div>
      <div class="right-button">
        <span @click="praise" v-if="worksData.praise_status === 0">
          <img
            class="right-button-praise-icon"
            src="@/image/workCenter/p5.png"
          />
          {{ worksData.praise_number }}
        </span>
        <span v-if="worksData.praise_status === 1">
          <img
            class="right-button-praise-icon"
            src="@/image/workCenter/p7.png"
          />
          {{ worksData.praise_number }}
        </span>
        <span>
          <router-link
            :to="{
              name: 'works_comment',
              params: { id: this.$route.params.id }
            }"
          >
            <img class="right-button-comment-icon" src="@/image/comment.png" />
          </router-link>
          {{ worksData.comment_number }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import workService from "@/global/service/work";
export default {
  data() {
    return {
      worksData: {},
      school: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    praise() {},
    getData() {
      let id = this.$route.params.id;
      workService.studentWorkDetail(id).then(res => {
        this.worksData = res;
        this.school = res.school;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.worksCenterdatails-section {
  width: 70%;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  color: #2c3e50;
  .datails-mark {
    border-bottom: 1px solid #e4e4e4;
    padding-bottom: 10px;
    /deep/.el-breadcrumb__item {
      font-size: 12px;
    }
  }
  .datails-title {
    font-size: 24px;
    color: #2c3e50;
    text-align: left;
    padding-top: 30px;
  }
  .datails-author {
    text-align: left;
    padding-top: 10px;
    span {
      padding-right: 20px;
    }
  }
  .datail-information {
    text-align: left;
    font-size: 12px;
    padding-top: 10px;
    .information-value {
      color: #f90;
    }
  }
  .datail-img {
    padding-top: 20px;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .datail-button-content {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    .right-button {
      font-size: 12px;
      span {
        padding-left: 10px;
        cursor: pointer;
        img {
          width: 28px;
          height: 28px;
        }
      }
      .right-button-praise-icon {
        width: 20px;
        height: 20px;
      }
      .right-button-comment-icon {
        width: 20px;
        height: 20px;
      }
    }
  }
  .worksCenterdatails-content {
    padding: 60px 20px 20px;
    font-size: 12px;
    .worksCenterdatails-remarks {
      padding-top: 30px;
      color: #606266;
      span {
        padding-right: 10px;
      }
    }
  }
}
</style>
<style lang="less">
.worksCenterdatails-content {
  .ql-align-center {
    line-height: 25px;
  }
}
</style>
